import { AUTHORIZATION_TO_SELL_STATUSES, type CatalogueStatus } from "../types";
import type { StatusPillTone } from "../design/StatusPill";
import { toCatalogueStatusPillMapping } from "../design/catalogueStatusPill";

/**
 * Choices for the shared two-state catalogue status ('pendiente' | 'validado').
 * SelectInput/SelectField translate a choice's `name` as a message key by
 * default, so these keys must exist in every locale's crm messages file.
 */
export const AUTHORIZATION_TO_SELL_STATUS_CHOICES: Array<{
  id: CatalogueStatus;
  name: string;
}> = AUTHORIZATION_TO_SELL_STATUSES.map((status) => ({
  id: status,
  name: `resources.developers.authorization_to_sell_status.${status}`,
}));

/**
 * Maps a developer's `authorization_to_sell_status` to a StatusPill tone
 * plus the i18n message key to translate. Reuses the same pure mapping as
 * {@link import("../projects/complianceStatus").complianceStatusToPill}
 * (MEMORY.md: the two catalogues share the same two values) -- its mapping
 * is exercised by projects/complianceStatus.test.ts, so no separate test
 * file is needed here (see TASK-051 notes).
 */
export function authorizationToSellStatusToPill(status: unknown): {
  tone: StatusPillTone;
  messageKey: string | null;
} {
  const { tone, labelKey } = toCatalogueStatusPillMapping(status);
  return {
    tone,
    messageKey: labelKey
      ? `resources.developers.authorization_to_sell_status.${labelKey}`
      : null,
  };
}
